// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  // console.log("Item added to the cart");
  // console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  // console.log("Cart updated");
  // console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  // console.log("Quick cart opened");
  // console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  // console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  // console.log("Product variant changed");
  // console.log(evt.detail.variant);

  /*
  let buyButtons = document.querySelector("#product-form__buy-buttons")

  var product_warningLabel = document.getElementById('product__warning');
  if (evt.detail.variant.option1.includes("Family Friendly") || evt.detail.variant.option2.includes("Family Friendly")) {
    product_warningLabel.innerHTML = "<p>Family Friendly: Ages 11+ with adult (18+) supervision.</p><p>All guests (including adult supervision) require a ticket.</p><p>One adult can bring a maximum of two children.</p>"; //"<p>These classes are family-friendly, whereby, children over the age of 11 are welcome to attend with adult supervision. The adult-to-child ratio must be one adult for every two children. All attendees (including adult supervisors) must purchase a ticket.</p>";
  } else {
      product_warningLabel.innerHTML = "";
  }
  */
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  // console.log("Product quantity updated");
  // console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  // console.log("Quickview loaded");
});


if(window.location.href.includes('event-facilitator-guide')) {
  var doc = document.querySelector('#facilitator__doc');
  doc.setAttribute('src',`https://docs.google.com/document/d/13z4hueQ09CbjyiQa17YNGsNeHbH3_SN4SYL-J2Ogx14/preview`);
}